import { httpClient } from "../http/httpClient";

export type AttachmentType = {
  documentId: string;
  nome: string;
  uploadedAt: string | null;
};

export type AttachmentsTypeResponse = {
  data: AttachmentType[];
};

export const attachmentsType = async (id: string) => {
  const { data } = await httpClient
    .get<AttachmentsTypeResponse>(`/transaction/${id}/attachments`)
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data.data;
};
